import { IRSState } from './types';

export const initialState: IRSState = {
  buyAnalyticsFreeReportData: {
    name: '',
    date: '',
    url: '',
  },
  buyAnalyticsLegalDocsUrl: '',
  bestPlaceAnalyticsReportExampleUrl: '',
  bestPlaceReportLegalDocsUrl: '',
  bestPlaceReportBaseUrl: '',
  bestPlaceReportProviderInfo: '',
  isPerformanceVasPilot: false,
  bookedFromDeveloperEnabled: false,
  kpnChat: {
    enabled: false,
  },

  /**
   * Код появился к проекту "Чёрная пятница" для компании "Этажи".
   * @todo: удалить в задаче CD-251228
   */
  etazhiBlackFridayEnabled: false,
  etazhiBlackFridayPromoOffersData: null,
};

export function rsReducer(state: IRSState = initialState): IRSState {
  return state;
}
